module.exports = __webpack_public_path__ + "46e1a374c49629e9429bba49501e0964.svg";